import { apiClient } from './client'
import type { ProjectDetail, PublishPreview } from './types'

export const publishProject = async (projectId: string): Promise<ProjectDetail> => {
  const response = await apiClient.post<ProjectDetail>(`/api/v1/projects/${projectId}/publish`)
  return response.data
}

export const fetchPublishPreview = async (projectId: string): Promise<PublishPreview> => {
  const response = await apiClient.get<PublishPreview>(
    `/api/v1/projects/${projectId}/publish/preview`
  )
  return response.data
}
